import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
  variant?: "default" | "condensed";
  textColor?: "white" | "primary" | "black";
  size?: "sm" | "md" | "lg";
}

export function Logo({
  className,
  variant = "default",
  textColor = "primary",
  size = "md",
}: LogoProps) {
  // Size mapping for the logo
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  // Size mapping for the text
  const textSizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-lg",
  };

  return (
    <Link to="/" className={cn("flex items-center no-underline", className)}>
      <div className="flex items-center">
        <div className="rounded-md p-1 flex items-center justify-center">
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/claire.png`}
            alt="Claire Logo"
            className={sizeClasses[size]}
          />
        </div>
        {variant === "default" && (
          <div
            className={cn(
              "font-semibold ml-[-10px] mt-[1px]",
              textSizeClasses[size],
              textColor === "white"
                ? "text-white"
                : textColor === "black"
                  ? "text-black"
                  : "text-primary"
            )}
          >
            laire
          </div>
        )}
      </div>
    </Link>
  );
}
